import { mapState, mapActions } from 'vuex'

export const baseMethods = mapActions('base', [
    'setCurrentLanguage',
    'setLoading',
    'getProfilesList',
    'switchProfileStatus',
    'setPageTitle',
    'setPedagogicType',
    'toggleRightPanel',
    'closeRightPanel',
    'sendWelcomeEmail',
    'setOverlay',
    'setEcommerceLegacyInfoAuth',
])

export const baseComputed = {
    ...mapState('base', [
        'loadingState',
        'currentLanguage',
        'isLoading',
        'profilesList',
        'pageTitle',
        'pedagogicTypeList',
        'isRightPanelOpen',
        'isOverlayActive',
        'ecommerceLegacyInfoAuth',
    ]),
}
